import Loader from 'react-loader-spinner';
import { useEffect, useRef, useState } from 'react';
import { Button, Form, Modal, Table } from 'react-bootstrap';
import { searchStorage4Modal } from '../../BaseInfo/store/api/StorageApi';
import { Search } from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalSearchStorage = (props) => {
    const inputStorageName = useRef();
    const { setStoragePoup, popData } = props;
    const [storageList, setStorageList] = useState([]);
    const { show, setStorageData, value, isStaffStorage } = popData;
    const close = () => {
        setStorageData(null);
        setStoragePoup({ show: false });
    };
    const search = () => {
        searchStorage4Modal(inputStorageName.current.value, 10, setStorageList, isStaffStorage);
    }
    const select = (item) => {
        if (setStorageData) {
            setStorageData(item);
            setStoragePoup({ show: false });
        }
    }
    function onStorageNameKeyDown(e) {
        if (e.key === "Enter") {
            search();
        }
        else if (e.keyCode === 27) {
            close();
        }
    }
    useEffect(() => {
        if (show) {
            inputStorageName.current.focus();
        }
        if (value) {
            inputStorageName.current.value = value;
        }
    }, [show])
    return (
        <Modal show={show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span><FontAwesomeIcon icon={faListAlt} size='lg' />&nbsp;انتخاب انبار</span>
                 <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />
                 </Modal.Header>
            <Modal.Body className='bodyStyle' style={{ paddingTop: "2px" }}>
                <div className="form-group mt-1" style={{position:"relative"}}>
                    <Form.Control ref={inputStorageName} placeholder="نام انبار" onKeyDown={onStorageNameKeyDown} />
                    <Button className="btn-input-tiny" onClick={search} style={{top:3, left:3}}><Search size={23} /></Button>
                </div>
                {storageList &&
                    <Table className="mt-2">
                        <thead>
                            <tr>
                                <th>نام انبار</th>
                            </tr>
                        </thead>
                        <tbody>
                            {storageList === "PENDING" &&
                                <tr>
                                    <td style={{ textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" height={25} width={25} /></td>
                                </tr>
                            }
                            {storageList.Error &&
                                <tr>
                                    <td style={{ textAlign: "center", color: "red" }}>{storageList.Error}</td>
                                </tr>
                            }
                            { Array.isArray(storageList?.Data) && storageList.Data.map((item, i) => {
                                return (
                                    <tr key={i} className="resultTableRow" onClick={() => select(item)}>
                                        <td>{item.StorageName}</td>
                                    </tr>)
                            }
                            )}
                        </tbody>
                    </Table>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalSearchStorage;